function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { cn } from "../../../lib/utils";
import { ArrowchevronDownIcon, ArrowchevronLeftIcon, ArrowchevronRightIcon, ArrowchevronUpIcon } from '@bfe/moly-icons';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var directionComp = {
  left: ArrowchevronLeftIcon,
  right: ArrowchevronRightIcon,
  top: ArrowchevronDownIcon,
  bottom: ArrowchevronUpIcon
};
var directionSpaceClass = {
  left: 'shadow-bds-shadow-right',
  right: 'shadow-bds-shadow-left',
  top: '',
  bottom: ''
};
var SliderBtnIcon = function SliderBtnIcon(_ref) {
  var className = _ref.className,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 16 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    iconWidth = _ref.iconWidth,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'left' : _ref$direction,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick;
  var IconComp = directionComp[direction];
  return /*#__PURE__*/_jsx("div", {
    onClick: handleClick,
    className: cn('flex justify-center items-center cursor-pointer shrink-0', directionSpaceClass[direction], className),
    style: {
      width: width,
      height: height,
      fontSize: iconWidth ? iconWidth : width
    },
    children: /*#__PURE__*/_jsx(IconComp, {})
  });
};
export var ExtraContent = function ExtraContent(_ref2) {
  var position = _ref2.position,
    extra = _ref2.extra;
  if (!extra) return null;
  var content;
  var assertExtra = {};
  if (_typeof(extra) === 'object' && ! /*#__PURE__*/React.isValidElement(extra)) {
    assertExtra = extra;
  } else {
    assertExtra.right = extra;
  }
  if (position === 'right') {
    content = assertExtra.right;
  }
  if (position === 'left') {
    content = assertExtra.left;
  }
  return content;
};
export default SliderBtnIcon;